import { Logger } from '@bixi/core/utils';

export const logger = new Logger({
  devOnly: true,
  onceOnly: true,
  withStack: true,
  prefix: ``
});
